export const DEALER_FLAG_TEXTILE = 'TEXTILE';
export const DEALER_FLAG_NON_TEXTILE = 'NON_TEXTILE';
